import { __awaiter, __decorate } from "tslib";
import CatalogItem from '@slickdeals/durango/dist/javascript/core/catalogItem';
import { catalogItem } from '@slickdeals/durango/dist/javascript/decorators/catalogItem';
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import Injector, { InjectorScope } from '@slickdeals/durango/dist/javascript/core/injector';
import { name as heapName } from '../heap/heap';
import '@slickdeals/blueprint-twig/javascript/components/linkableButton';
import '@slickdeals/blueprint-twig/javascript/components/image';
import '../../scss/patterns/cashbackInfo.scss';
export const name = 'CashbackInfo';
export const dependencies = Object.assign({}, Injector.createDependency(heapName, InjectorScope.Singleton));
let CashbackInfo = class CashbackInfo extends CatalogItem {
    constructor(heap, options) {
        super(options);
        this.heap = heap;
        this.options = options;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            _super.init.call(this);
            this.element = yield CatalogItem.loadElement(name, this.options);
            this.trackImpression();
        });
    }
    trackImpression() {
        this.heap.track('Rewards For All CashbackInfo - Impression').catch(() => { });
    }
};
CashbackInfo = __decorate([
    injectable(name, dependencies),
    catalogItem(name)
], CashbackInfo);
export default CashbackInfo;
